import { AuthProvider } from "@/auth/components/AuthProvider";
import { Routes } from "@/app/components/Routes";
import { queryClient } from "@/app/services/queryClient";
import { sentryBeforeSend } from "@/app/services/sentryBeforeSend";
import { ThemeProvider } from "@/common/components/ThemeProvider";
import "@repo/ui/main.css";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@ui/components/ui/toaster";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    beforeSend: sentryBeforeSend,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <Routes />
                        <Toaster />
                    </AuthProvider>
                </BrowserRouter>
            </ThemeProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
